import type { IconSvgObject } from './types';

const ScreenAddToHomeIcon: IconSvgObject = [
  ["path", { d: "M6 9H11V14M10.5 9.5L4 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 17V20.5C7 21.3284 7.67157 22 8.5 22H18.5C19.3284 22 20 21.3284 20 20.5V3.5C20 2.67157 19.3284 2 18.5 2H8.5C7.67157 2 7 2.67157 7 3.5V6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M13.625 19H13.5M13.75 19C13.75 19.1381 13.6381 19.25 13.5 19.25C13.3619 19.25 13.25 19.1381 13.25 19C13.25 18.8619 13.3619 18.75 13.5 18.75C13.6381 18.75 13.75 18.8619 13.75 19Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ScreenAddToHomeIcon;
